import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private readonly currentLanguageSbj = new BehaviorSubject<string>('');

  currentLanguage: string;
  currentLanguage$ = this.currentLanguageSbj.asObservable();

  constructor() {
    this.getCurrentLanguage();
  }

  getCurrentLanguage() {
    const myHref = window.location.href;
    const languages = ['it', 'en', 'fr'];
    languages.forEach(l => {
      if (myHref.search('/' + l + '/') !== -1) {
        this.currentLanguage = l;
        this.currentLanguageSbj.next(this.currentLanguage);
      }
    });
  }

  setLanguage(language) {
    this.currentLanguageSbj.next(language);
  }
}
